import CurrentLeaderboardItem from "../events/event/leaderboards/current-leaderboard-item";
import { selectLeaderboard } from "../../reducers/leaderboardSlice";
import { useSelector } from "react-redux";
import { getRouting } from "../../helpers/Converters";
import { eventBaseRoute } from "../../routes/event";
import { useTournament } from "../../hooks/tournamentHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const CurrentLeaderboardWidget = () => {

  const currentLeaderboard = useSelector(selectLeaderboard)
  const navigate = useGolfstatusNavigate()

  const tournament = useTournament()

  return  <CurrentLeaderboardItem
  {...currentLeaderboard}
  navigate={() => {
    navigate?.(
      getRouting(eventBaseRoute, [
        tournament?.publicUrl,
        "leaderboards",
        currentLeaderboard?.id,
        "select",
      ])
    );
  }}
/>

}

export default CurrentLeaderboardWidget